import Raven from 'raven-js';
// Raven.config('https://455bf5ede47d4e7ca53dc14bb583eb68@errors.danemco.net/50').install();

import Vue from 'vue';
import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue'
import AsyncComputed from 'vue-async-computed';
// import { mixin as focusMixin }  from 'vue-focus';

import 'babel-polyfill';

Vue.use(VueRouter);
Vue.use(AsyncComputed);
Vue.use(BootstrapVue);

import moment from 'moment';

// Vue.mixin(focusMixin);
Vue.mixin({
  methods: {
    moment,
  },
});

import App from './fitting.vue';

window.FittingApp = new Vue(App);
window.FittingApp.$mount('#fitting');
